/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrInput from "@grapecity/wijmo.react.input"
import * as wjcInput from "@grapecity/wijmo.input"

import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import { RootState } from "../../../globalStore/rootreducer"
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import VacationListModal from "./VacationListModal"
import VacationHuyoModal from "./VacationHuyoModal"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import VacationService from "../../../service/attendance/vacation/vacationService"
import {
  TVacationGetReq,
  TVacationGetRes,
  TVacationPrintVacationKanriReq,
} from "../../../service/attendance/vacation/TVacation"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import BusyoService from "../../../service/master/busyo/busyoService"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import commonUtil from "../../../ts/util/commonUtil"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import KubunService from "../../../service/master/kubun/kubunService"
import { 区分分類コード, 社員_乗務員 } from "../../../constant/enum/codes"
import VacationChangeModal from "./VacationChangeModal"
import { FunctionContext } from "../../../components/Context"
import {
  vacationExcelFormat,
  vacationPdfFormat,
} from "../../../ts/util/haisyaUtil"
import { e入社区分 } from "../../../constant/enum/syain"
import SystemService from "../../../service/system/systemService"
import kengenUtil from "../../../ts/util/kengenUtil"
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"

// #region [type]

export type T勤怠管理リスト = TVacationGetRes & { 行ID: symbol }

//#endregion

/**
 * 勤怠管理一覧
 * @returns
 */
const Vacation = () => {
  const history = useHistory()
  const location = useLocation()
  const userInfo = useSelector(
    (rootState: RootState) => rootState.user.LoginUserInfo
  )
  const has有休編集権限 =
    kengenUtil.有休管理画面の有休付与と変更ボタンの使用権限判定(userInfo)
  const has他部所閲覧権限 =
    kengenUtil.有休管理画面の他部所閲覧権限判定(userInfo)

  //TODO:ページ名称確定必須
  let gridId = "Vacation_GridId"

  //#region [method]

  interface ICalculatedFields {
    calculated_繰越日数: number
    calculated_付与日数: number
    calculated_保有日数: number
    calculated_有休日数: number
    calculated_有休残日数: number
    calculated_特休日数: number
    calculated_介護日数: number
    calculated_欠勤日数: number
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TVacationGetRes>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        // sort
        sort_部所コード: (i: TVacationGetRes & ICalculatedFields) =>
          commonUtil.createSortString(
            i.部所コード,
            VALIDATE_CONSTANT.LENGTH.部所コード
          ),
        sort_社員コード: (i: TVacationGetRes & ICalculatedFields) =>
          commonUtil.createSortString(
            i.社員コード,
            VALIDATE_CONSTANT.LENGTH.社員コード
          ),
        // 日数項目がnullの場合、0表示させる
        calculated_繰越日数: (i: TVacationGetRes & ICalculatedFields) => {
          if (!i.繰越日数) {
            return 0
          }
          return i.繰越日数
        },
        calculated_付与日数: (i: TVacationGetRes & ICalculatedFields) => {
          if (!i.付与日数) {
            return 0
          }
          return i.付与日数
        },
        calculated_保有日数: (i: TVacationGetRes & ICalculatedFields) => {
          if (!i.保有日数) {
            return 0
          }
          return i.保有日数
        },
        calculated_有休日数: (i: TVacationGetRes & ICalculatedFields) => {
          if (!i.有休日数) {
            return 0
          }
          return i.有休日数
        },
        calculated_有休残日数: (i: TVacationGetRes & ICalculatedFields) => {
          if (!i.有休残日数) {
            return 0
          }
          return i.有休残日数
        },
        calculated_特休日数: (i: TVacationGetRes & ICalculatedFields) => {
          if (!i.特休日数) {
            return 0
          }
          return i.特休日数
        },
        calculated_介護日数: (i: TVacationGetRes & ICalculatedFields) => {
          if (!i.介護日数) {
            return 0
          }
          return i.介護日数
        },
        calculated_欠勤日数: (i: TVacationGetRes & ICalculatedFields) => {
          if (!i.欠勤日数) {
            return 0
          }
          return i.欠勤日数
        },
      },

      sortDescriptions: [
        new wjCore.SortDescription("sort_部所コード", true),
        new wjCore.SortDescription("sort_社員コード", true),
      ],

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TVacationGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TVacationGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    if (currentSearchCondition == null) return
    setPreSearchCondition({ ...currentSearchCondition })

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new VacationService().getList(currentSearchCondition)
      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })

      // Modal用に年度を保存
      setモーダル用年度(currentSearchCondition.年度)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TVacationGetReq = queryString.parse(location.search)
    set年度(parseInt(query.年度!))
    set付与月(query.入社区分コード)
    set部所コード(query.部所コード)
    set社員区分コード(query.社員区分コード)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TVacationGetReq => {
    return {
      年度: 年度 != null ? 年度.toString() : undefined,
      入社区分コード: 付与月 ?? undefined,
      部所コード: 部所コード ?? undefined,
      社員区分コード: 社員区分コード ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (searchCondition: TVacationGetReq) => {
    const disp付与月区分 = 区分ItemSource?.find(
      (i) =>
        i.区分コード === searchCondition.入社区分コード &&
        i.分類コード === 社員_乗務員.入社区分
    )

    const disp部所 = 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.部所コード
    )

    const disp社員区分 = 区分ItemSource?.find(
      (i) =>
        i.区分コード === searchCondition.社員区分コード &&
        i.分類コード === 社員_乗務員.社員区分
    )

    return {
      年度: wjCore.isNullOrWhiteSpace(searchCondition.年度 ?? "")
        ? ""
        : searchCondition.年度,
      付与月: disp付与月区分?.名称1,
      部所: disp部所?.部所略称,
      社員区分: disp社員区分?.名称1,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)
    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set年度(ref当年度.current)
    set付与月("")
    set部所コード("")
    set社員区分コード("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // header行に一行追加
    // 追加行のみ初期化時に設定
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      c.allowMerging = true
      // 列結合
      if (
        c.binding === "部所略称" ||
        c.binding === "社員コード" ||
        c.binding === "社員氏名"
      )
        columnHeaders.setCellData(0, index, "所属")

      if (
        c.binding === "社員区分名称1" ||
        c.binding === "入社年月日" ||
        c.binding === "勤続年数" ||
        c.binding === "最新付与日"
      )
        columnHeaders.setCellData(0, index, "社員情報")

      if (c.binding === "アラートフラグ")
        columnHeaders.setCellData(0, index, "アラート対象")

      if (
        c.binding === "calculated_繰越日数" ||
        c.binding === "calculated_付与日数" ||
        c.binding === "calculated_保有日数"
      )
        // c.align = "right"
        columnHeaders.setCellData(0, index, "年度開始有休保有")
      if (
        c.binding === "calculated_有休日数" ||
        c.binding === "calculated_有休残日数" ||
        c.binding === "calculated_特休日数" ||
        c.binding === "calculated_介護日数" ||
        c.binding === "calculated_欠勤日数"
      )
        // c.align = "right"
        columnHeaders.setCellData(0, index, "年度取得休暇日数")

      if (c.binding == null) {
        columnHeaders.setCellData(0, index, c.header)
      }
    })

    // ヘッダのみAlignを調整する
    grid.itemFormatter = (panel, r, c, cell) => {
      if (
        panel.cellType === wjcGrid.CellType.ColumnHeader &&
        (cell.innerHTML === "所属" ||
          cell.innerHTML === "社員情報" ||
          cell.innerHTML === "年度開始有休保有" ||
          cell.innerHTML === "年度取得休暇日数")
      ) {
        cell.style.textAlign = "center"
      }
      if (
        panel.cellType === wjcGrid.CellType.ColumnHeader &&
        (cell.innerHTML === "繰越" ||
          cell.innerHTML === "付与" ||
          cell.innerHTML === "保有" ||
          cell.innerHTML === "有休" ||
          cell.innerHTML === "残数" ||
          cell.innerHTML === "特別" ||
          cell.innerHTML === "介護" ||
          cell.innerHTML === "欠勤")
      ) {
        cell.style.textAlign = "center"
      }
    }

    // ヘッダの設定
    // grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const ref当年度 = useRef<number>()

  const [部所コード, set部所コード] = useState<string | null>()
  const [年度, set年度] = useState<number>()
  const [社員ID, set社員ID] = useState<number>()
  const [社員区分コード, set社員区分コード] = useState<string | null>()
  const [付与月, set付与月] = useState<string | null>()
  const [更新対象有休残管理, set更新対象有休残管理] =
    useState<TVacationGetRes>()

  // モーダル
  //modal（有給取得一覧）
  const [isVacationListModalShow, setIsVacationListModalShow] =
    useState<boolean>(false)

  //modal(保有数変更)
  const [isVacationChangeModalShow, setIsVacationChangeModalShow] =
    useState<boolean>(false)

  //modal（有給付与処理）
  const [isVacationHuyoModalShow, setIsVacationHuyoModalShow] =
    useState<boolean>(false)
  const [モーダル用年度, setモーダル用年度] = useState<string>()

  // モーダル側との検索動作判定用
  const [preSearchCondition, setPreSearchCondition] = useState<TVacationGetReq>(
    {} as TVacationGetReq
  )

  //#region comboboxState
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  // 社員区分
  const [社員区分ComboBox, set社員区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [社員区分IsLoadEnded, set社員区分IsLoadEnded] = useState<boolean>(false)

  // 付与月
  const [付与月ComboBox, set付与月ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [付与月IsLoadEnded, set付与月IsLoadEnded] = useState<boolean>(false)

  // ComboBox制御
  const [comboDataInitialized, setComboDataInitialized] =
    useState<boolean>(false)
  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `有給管理`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
      new SystemService().getNendo(),
    ]).then(([部所ListRes, 区分マスタRes, 年度Res]) => {
      set部所ItemSource(部所ListRes.data)
      set区分ItemSource(区分マスタRes.data)
      ref当年度.current = 年度Res.data
      set年度(年度Res.data)
    })
  }, [])

  // Component生成確認
  useEffect(() => {
    if (!部所IsLoadEnded || !付与月IsLoadEnded || !社員区分IsLoadEnded) return

    setComboDataInitialized(true)
  }, [部所IsLoadEnded, 付与月IsLoadEnded, 社員区分IsLoadEnded])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        let querySearchCondition = queryParse()

        // クエリで別部所検索ができないよう制御
        if (!has他部所閲覧権限) {
          set部所コード(userInfo.部所コード)
          querySearchCondition = {
            ...querySearchCondition,
            部所コード: userInfo.部所コード,
          }
        }

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 他部所閲覧権限が無い場合は自部所のコードをセット
        if (!has他部所閲覧権限) {
          set部所コード(userInfo.部所コード)
        }

        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, comboDataInitialized])

  //#endregion

  /**
   * 有給管理簿印刷処理
   */
  const printTVacationPrintVacationKanriReq = async (
    searchCondition?: TVacationGetReq
  ) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    //検索条件の生成
    let currentSearchCondition: TVacationGetReq

    // 検索ボタン押下時の条件から検索条件を生成
    currentSearchCondition = preSearchCondition

    const printCondition: TVacationPrintVacationKanriReq = {
      部所コード: currentSearchCondition.部所コード,
      社員区分コード: currentSearchCondition.社員区分コード,
      年度: currentSearchCondition.年度,
      入社区分コード: currentSearchCondition.入社区分コード,
    }

    try {
      const service = new VacationService({ responseType: "blob" })
      const res = await service.printVacationKanriReq(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">有給管理</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-60rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <wjrInput.InputNumber
                              initialized={(control: wjcInput.InputNumber) => {
                                control.inputElement?.focus()
                              }}
                              style={{ width: "5rem" }}
                              id="年"
                              name="年"
                              placeholder="年"
                              format={"g0"}
                              isRequired={true}
                              value={年度}
                              valueChanged={(
                                c: wjcInput.InputNumber,
                                e: any
                              ) => {
                                c.value != null
                                  ? set年度(c.value)
                                  : set年度(undefined)
                              }}
                            />
                            <ComboBox.Kubun
                              placeholder="付与月"
                              分類コード={区分分類コード.社員_乗務員.入社区分}
                              isAllSelect={false}
                              itemsSource={区分ItemSource}
                              isLoadEnded={付与月IsLoadEnded}
                              setIsLoadEnded={set付与月IsLoadEnded}
                              setSelectedValue={set付与月}
                              selectedValue={付与月}
                              listFilter={(item) =>
                                item.区分コード !== e入社区分.付与対象外
                              }
                              ComboBox={付与月ComboBox}
                              setComboBox={set付与月ComboBox}></ComboBox.Kubun>
                          </div>
                          <div className="search-condition-row">
                            <ComboBox.Busyo
                              placeholder="部所"
                              isDisabled={!has他部所閲覧権限}
                              isAllSelect={true}
                              itemsSource={部所ItemSource}
                              isLoadEnded={部所IsLoadEnded}
                              setIsLoadEnded={set部所IsLoadEnded}
                              setSelectedValue={set部所コード}
                              selectedValue={部所コード}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                            <ComboBox.Kubun
                              placeholder="社員区分"
                              分類コード={区分分類コード.社員_乗務員.社員区分}
                              isAllSelect={true}
                              itemsSource={区分ItemSource}
                              isLoadEnded={社員区分IsLoadEnded}
                              setIsLoadEnded={set社員区分IsLoadEnded}
                              setSelectedValue={set社員区分コード}
                              selectedValue={社員区分コード}
                              ComboBox={社員区分ComboBox}
                              setComboBox={
                                set社員区分ComboBox
                              }></ComboBox.Kubun>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>

      <FunctionContext.Provider
        value={() => {
          search(preSearchCondition)
        }}>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  searchConditionClear={searchConditionClear}
                  gridId={gridId}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  gridInitializedHandler={gridInitializedHandler}
                  excelFormatItem={vacationExcelFormat}
                  pdfFormatItem={vacationPdfFormat}
                  hasFilter={false}
                  gridProperties={{
                    allowSorting: wjcGrid.AllowSorting.MultiColumn,
                    allowDragging: wjcGrid.AllowDragging.None,
                  }}
                  headerComponent={
                    <div className="d-flex">
                      {has有休編集権限 && (
                        <button
                          className="btn btn-primary me-2"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )
                            setIsVacationHuyoModalShow(true)
                          }}>
                          有給付与処理
                        </button>
                      )}
                      <Button
                        className="btn-done"
                        onClick={() => {
                          printTVacationPrintVacationKanriReq()
                        }}
                        disabled={gridData.data.itemCount === 0}>
                        <FontAwesomeIcon icon={faFileAlt} />
                        有給管理簿印刷
                      </Button>
                    </div>
                  }>
                  <wjrGrid.FlexGridColumn
                    binding="部所略称"
                    width={200}
                    sortMemberPath="sort_部所コード"
                    header="部所"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="社員コード"
                    width={90}
                    sortMemberPath="sort_社員コード"
                    header="社員番号"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="社員氏名"
                    width={128}
                    header="氏名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="社員区分名称1"
                    width={160}
                    header="社員区分"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="入社年月日"
                    width={100}
                    header="入社日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TVacationGetRes>
                      ) => {
                        return (
                          <>
                            {context.item.入社年月日 &&
                              wjCore.Globalize.format(
                                new Date(context.item.入社年月日),
                                "d"
                              )}
                          </>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    align="left"
                    binding="勤続年数"
                    width={100}
                    header="付与時勤続年">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TVacationGetRes>
                      ) => {
                        if (context.item.勤続年数 == null)
                          return <>付与対象外</>
                        if (context.item.勤続年数 < 0) return <>付与対象外</>
                        return <>{context.item.勤続年数}年目</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="最新付与日"
                    width={100}
                    header="最新付与日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TVacationGetRes>
                      ) => {
                        return (
                          <>
                            {context.item.最新付与日 &&
                              wjCore.Globalize.format(
                                new Date(context.item.最新付与日),
                                "d"
                              )}
                          </>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    header="アラート対象"
                    binding="アラートフラグ"
                    wordWrap={true}
                    allowMerging="true"
                    align="center"
                    width={70}
                    selectable={false}
                    isReadOnly>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TVacationGetRes>
                      ) => {
                        if (context.item.アラートフラグ === 1) {
                          return (
                            <FontAwesomeIcon
                              icon={faExclamationTriangle}
                              size={"1x"}
                              color={"red"}
                            />
                          )
                        }
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="calculated_繰越日数"
                    width={50}
                    dataType={wjCore.DataType.Number}
                    format="N1"
                    header="繰越"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="calculated_付与日数"
                    width={50}
                    dataType={wjCore.DataType.Number}
                    format="N1"
                    header="付与"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="calculated_保有日数"
                    width={50}
                    dataType={wjCore.DataType.Number}
                    format="N1"
                    header="保有"></wjrGrid.FlexGridColumn>

                  <wjrGrid.FlexGridColumn
                    binding="calculated_有休日数"
                    width={50}
                    dataType={wjCore.DataType.Number}
                    format="N1"
                    header="有休"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="calculated_有休残日数"
                    width={50}
                    dataType={wjCore.DataType.Number}
                    format="N1"
                    header="残数"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="calculated_特休日数"
                    width={50}
                    dataType={wjCore.DataType.Number}
                    format="N1"
                    header="特別"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="calculated_介護日数"
                    width={50}
                    dataType={wjCore.DataType.Number}
                    format="N1"
                    header="介護"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="calculated_欠勤日数"
                    width={50}
                    dataType={wjCore.DataType.Number}
                    format="N1"
                    header="欠勤"></wjrGrid.FlexGridColumn>

                  <wjrGrid.FlexGridColumn
                    header="取得詳細"
                    align="center"
                    width={90}
                    selectable={false}
                    isReadOnly>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TVacationGetRes>
                      ) => {
                        return (
                          <Button
                            className="btn btn-small btn-primary move-edit-page"
                            onClick={() => {
                              // 画面全体のスクロール位置の保存
                              gridPageHelper.savePageConditionData(
                                location.pathname
                              )
                              set社員ID(context.item.社員ID)
                              setIsVacationListModalShow(true)
                            }}>
                            取得一覧
                          </Button>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  {has有休編集権限 && (
                    <wjrGrid.FlexGridColumn
                      header="保有数変更"
                      align="center"
                      width={100}
                      selectable={false}
                      isReadOnly>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TVacationGetRes>
                        ) => {
                          const castedモーダル用年度 = parseInt(
                            モーダル用年度 ?? "0"
                          )
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              disabled={
                                ref当年度.current == null ||
                                ref当年度.current < castedモーダル用年度 ||
                                2 <= ref当年度.current - castedモーダル用年度
                              }
                              onClick={() => {
                                // 画面全体のスクロール位置の保存
                                gridPageHelper.savePageConditionData(
                                  location.pathname
                                )
                                set更新対象有休残管理(context.item)
                                setIsVacationChangeModalShow(true)
                              }}>
                              保有数変更
                            </Button>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                  )}
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {/* 取得一覧 */}
        <VacationListModal
          isShow={isVacationListModalShow}
          setIsShow={setIsVacationListModalShow}
          syainId={社員ID?.toString()}
          nendo={モーダル用年度}></VacationListModal>
        {/* 保有数変更 */}
        <VacationChangeModal
          isShow={isVacationChangeModalShow}
          setIsShow={(v) => {
            setIsVacationChangeModalShow(v)
          }}
          changeTarget={更新対象有休残管理}></VacationChangeModal>
        {/* 一括付与 */}
        <VacationHuyoModal
          isShow={isVacationHuyoModalShow}
          setIsShow={setIsVacationHuyoModalShow}
          successHandler={() => {
            search(preSearchCondition)
          }}></VacationHuyoModal>
      </FunctionContext.Provider>
    </Container>
  )
}

export default Vacation
